import commonGetters from '@/store/data/common/getters'
import { filter, find, includes, isNil, toString, uniq, concat, toLower } from 'lodash'

const getters = {
    getConnectionList: state => () => {
        return filter(state.list, item => item.jsonKey.type === 'connection')
    },

    //retrieve connection with config parentJsonKeyName (child => parent)
    getConnectionByJobParentJsonKeyName: (_state, getters) => params => {
        const connection = find(getters.getConnectionList(), item => item.jsonKey.name === params.parentJsonKeyName)
        return isNil(connection) ? null : connection
    },

    getConnectionFromConnectionId: (_state, getters) => params => {
        return find(getters.getConnectionList(), item => item.id === params.id)
    },

    //retrieve config with connection id (parent => child)
    getConfigurationListByParentJsonKeyName: state => params => {
        return filter(state.list, item => item.jsonKey.type === 'configuration' && item.parentJsonKeyName === params.jsonKeyName)
    },

    //retrieve config with job parentJsonKeyName (child => parent)
    getConfigurationByJobParentJsonKeyName: state => params => {
        const config = find(state.list, item => item.jsonKey.type === 'configuration' && item.jsonKey.name === params.parentJsonKeyName)
        return isNil(config) ? null : config
    },

    getJobList: state => () => {
        return filter(state.list, item => item.jsonKey.type === 'job')
    },

    getJobListByParentJsonKeyName: (_state, getters) => params => {
        return filter(getters.getJobList(), item => item.parentJsonKeyName === params.jsonKeyName)
    },

    getJobsSearchResults: (_state, getters) => params => {
        if (params.searchValue === '') return getters.getJobList()

        const searchPattern = params.searchValue
        const searchType = params.type
        const dataList = getters.getJobList()
        let results = []
        let resultId = []
        let resultLabel = []

        if (searchType === 'filename' || searchType === '') {
            resultLabel = filter(dataList, elem => {
                return includes(toLower(elem.filename), toLower(searchPattern))
            })
        }
        if (searchType === 'id' || searchType === '') {
            resultId = filter(dataList, elem => {
                return includes(toString(elem.id), searchPattern)
            })
        }

        results = uniq(concat([], resultId, resultLabel))
        return results
    },

    getItemById: (_state, getters) => params => {
        const item = getters.getSearchedItems({
            id: params.id,
            jsonKeyType: params.dataType
        })
        return item.length === 1 ? item[0] : null
    }

    /*
    getDataEntryTypeList: (state, getters, rootState, rootGetters) => params => {
        return filter(state.list, item => item.jsonKey.type === params.type)
    },

    getConnectionAndConfigurationList: (state, getters, rootState, rootGetters) => params => {
        let connectionList = getters.getDataEntryTypeList({ type: 'connection' })
        let configurationList = getters.getDataEntryTypeList({ type: 'configuration' })

        return connectionList.concat(configurationList)
    },
    */
}

export default { ...commonGetters, ...getters }
